// Axios: Peticiones HTTP via Ajax
import axios from 'axios';

export const swal = require('sweetalert2');

swal.setDefaults({
    customClass: 'register-global-swal',
    confirmButtonClass: 'register-swal-btn register-swal-btn-primary',
    cancelButtonClass: 'register-swal-btn register-swal-btn-secondary',
    confirmButtonText: 'Entendido',
    buttonsStyling: false,
    reverseButtons: true,
});

export const HttpYULI = axios.create({
    baseURL: '/yulibackend/',
});

export const HttpGEO = axios.create({
    baseURL: '/geoobjectbackend/',
});

export const HttpFRONT = axios.create({
    baseURL: '/',
});
